<template>
  <a-cascader 
    ref="cascader"
    :options="animal"
    :load-data="loadAnimalData"
    @change="onChange"
    :value="val"
    change-on-select
    :placeholder='placeholder'
    />
</template>

<script>
import {nhfMixins} from '../../untils'

export default {
  name:'AnimalSelect',
  props:{
    val:{
      type:Array,
      default:function(){
        return []
      }
    },
    placeholder:{
      type:String,
      default:'选择动物类型'
    }
  },
  mixins:[nhfMixins],
  data(){
    return {
      animal:[],
    }
  },

  async mounted(){
      let factoryId = window.localStorage.getItem('factoryId')
    const res = await this.animalTypeList({parentId:0,factoryId})
    const {data} = res
    if(data && data.length && data[0].id){
      const resAnimal = await this.animalTypeList({parentId:data[0].id,factoryId})
      this.animal = resAnimal.data.map(this.mapFilter)
    } else{
      this.animal = res.data.map(this.mapFilter)
    }
  },

  methods: {
    onChange(val,selected){
      this.$emit('change', val)
      this.$emit('select', selected)
    },

    mapFilter (i) {
      return {
        ...i,
        label:i.name,
        value:i.id,
        isLeaf: !i.hasChildren
      } 
    },

    async loadAnimalData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1]
      targetOption.loading = true
      const {value:parentId} = targetOption
      let factoryId = window.localStorage.getItem('factoryId')
      const res = await this.animalTypeList({parentId,factoryId})
      targetOption.loading = false
      targetOption.children = res.data.map(this.mapFilter)
      this.animal = [...this.animal]
    },
  }

}
</script>